import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ChartingIndex from '../components/patient/Charting/Charting';

import * as chartingActions from '../actions/charting';

function mapStateToProps(state) {
    return {
        charting: state.charting,
        auth: state.auth,
        isLoading: state.isLoading
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(chartingActions, dispatch);
}

const Index = connect(mapStateToProps, mapDispatchToProps)(ChartingIndex);

export default Index;


/** WEBPACK FOOTER **
 ** ./src/containers/Charting.js
 **/